import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Drop-in replacement for Amplify v3 `Auth.currentSession()` so legacy
 * screens can keep `user.getIdToken().getJwtToken()` calls.
 */
export function currentSession() {
  return fetchAuthSession({ forceRefresh: true }).then((session) => {
    const token = session.tokens?.idToken?.toString();
    if (!token) {
      throw new Error('Not authenticated');
    }
    return {
      getIdToken: () => ({
        getJwtToken: () => token,
      }),
    };
  });
}
